/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */

import { ChangeDetectionStrategy, Component, Host, Optional, inject } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import * as appStrings from '@touchplan/strings';
import { Observable, combineLatest, distinctUntilChanged, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { MaterialModule } from '../material/material-module';
import { CommonModule } from '@angular/common';

/**
 * A thin wrapper around a mat-error that showup when a form is submitted and invalid
 */
@Component({
	selector: 'tp-form-auto-error',
	standalone: true,
	imports: [CommonModule, MaterialModule],
	template: `<mat-error *ngIf="displayError | async">${appStrings.GENERAL_FIX_ALL_ERRORS}</mat-error>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormAutoErrorComponent {
	//can add a @Input here if we ever need to customize the error, I'd rather discourage it
	protected displayError: Observable<boolean>;

	constructor(@Optional() private formGroupDirective: FormGroupDirective) {}

	ngOnInit() {
		if (this.formGroupDirective) {
			this.displayError = combineLatest([
				this.formGroupDirective.ngSubmit,
				this.formGroupDirective.statusChanges.pipe(distinctUntilChanged()),
			]).pipe(map(() => this.formGroupDirective.invalid));
		} else {
			this.displayError = of(false);
		}
	}
}
